import FileUpload from 'views/molecules/FileUpload/FileUpload';

export default FileUpload;
